import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZCreateGatewayApiResponse = z.object({
  id: z.string().optional(),
  asset_id: z.string().optional(),
  name: z.string()
})

export interface CreateGatewayPostRequest {
  type?: string
  name: string
  description: string
  ip_address: string
  port: string
  install_date: string
  site_id: string
  asset_id?: string
  asset_type_id?: string
  gateway_type_id?: string
}

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZCreateGatewayApiResponse,
  error: z.boolean()
})

export type CreateGatewayApiResponse = z.infer<typeof ZCreateGatewayApiResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function createGateway (
  createGatewayPostRequest: CreateGatewayPostRequest,
  onSuccess: (successResponse: CreateGatewayApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/assetrest/api/v2/udp/tiq/assets'

  interceptedAxios
    .post(url, createGatewayPostRequest, { timeout: 15000 })
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)

      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
